if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();

        // Prevent popup on Shopify robot challenge page
        if (
          window.location.pathname === '/challenge' ||
          !theme.cookiesEnabled
        ) {
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        } else {
          new theme.initWhenVisible(
            theme.utils.throttle(this.init.bind(this))
          );
        }
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay')
          ? parseInt(this.getAttribute('data-delay'), 10)
          : 5;
      }

      get expiry() {
        return this.hasAttribute('data-expiry')
          ? parseInt(this.getAttribute('data-expiry'), 10)
          : 30;
      }

      get cookieName() {
        return 'concept:newsletter-popup';
      }

      get submitted() {
  const params = new URLSearchParams(window.location.search);

  const contactPosted =
    params.get('contact_posted') === 'true';

  const hasMessage =
    this.querySelector(
      '.alert--success, .alert--error, .form-status'
    ) !== null;

  return contactPosted || hasMessage;
}

get successfulSubmission() {
  const params = new URLSearchParams(window.location.search);

  const contactPosted =
    params.get('contact_posted') === 'true';

  const hasSuccessMessage =
    this.querySelector('.alert--success') !== null;

  return contactPosted || hasSuccessMessage;
}

trackGoogleAdsConversion() {
  // Prevent the same conversion firing again on refresh
  const conversionKey = 'smart-home-survey-conversion-fired';

  if (sessionStorage.getItem(conversionKey) === 'true') {
    return;
  }

  if (typeof window.gtag !== 'function') {
    console.warn('Google Ads conversion not fired: gtag is unavailable.');
    return;
  }

  window.gtag('event', 'conversion', {
    send_to: 'AW-865015061/SfYsCMCQnNccEJWqvJwD'
  });

  sessionStorage.setItem(conversionKey, 'true');
}

init() {
  if (this.initialized) return;

  this.initialized = true;

  // Reopen modal after Shopify contact form submission
  if (this.submitted) {
    this.load(0.2);

    if (this.successfulSubmission) {
      this.trackGoogleAdsConversion();
    }

    return;
  }

  // Keep automatic timed popup disabled
  /*
  if (this.testMode || !this.getCookie(this.cookieName)) {
    this.load(this.delay);
  }
  */
}

      load(delay = 0) {
  setTimeout(() => {
    this.show();

    const message = this.querySelector(
      '.alert--success, .alert--error, .form-status'
    );

    if (message) {
      message.setAttribute('tabindex', '-1');
      message.focus();
    }
  }, delay * 1000);
}

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(
          `(^|;)\\s*${name}\\s*=\\s*([^;]+)`
        );

        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie =
          `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

  const trackingFields = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid'
  ];

  /*
   * Save attribution details.
   * localStorage keeps them if the visitor moves between pages
   * or returns to the site later.
   */
  trackingFields.forEach((field) => {
    const value = params.get(field);

    if (value && !localStorage.getItem(`smartech_${field}`)) {
      localStorage.setItem(`smartech_${field}`, value);
    }
  });

  /*
   * Save the visitor's original landing page.
   */
  if (!localStorage.getItem('smartech_first_page')) {
    localStorage.setItem(
      'smartech_first_page',
      window.location.pathname
    );
  }

  if (!localStorage.getItem('smartech_landing_url')) {
    localStorage.setItem(
      'smartech_landing_url',
      window.location.href
    );
  }

  if (!localStorage.getItem('smartech_referrer')) {
    localStorage.setItem(
      'smartech_referrer',
      document.referrer || ''
    );
  }

  /*
   * Determine lead source.
   */
  let leadSource = 'Direct';

  const utmSource =
    localStorage.getItem('smartech_utm_source') || '';

  const gclid =
    localStorage.getItem('smartech_gclid') || '';

  const referrer =
    localStorage.getItem('smartech_referrer') || '';

  if (gclid || utmSource.toLowerCase() === 'google') {
    leadSource = 'Google Ads';
  } else if (utmSource) {
    leadSource = utmSource;
  } else if (referrer) {
    leadSource = 'Referral';
  }

  /*
   * Detect device type.
   */
  const device = /Mobi|Android|iPhone|iPad/i.test(
    navigator.userAgent
  )
    ? 'Mobile / Tablet'
    : 'Desktop';

  const setTrackingValue = (form, field, value) => {
    const input = form.querySelector(
      `[data-tracking="${field}"]`
    );

    if (input) {
      input.value = value || '';
    }
  };

  document
    .querySelectorAll(
      '.newsletter-form, .smart-home-survey-form'
    )
    .forEach((form) => {
      const startedAt = form.querySelector(
        '[data-form-started-at]'
      );

      if (startedAt) {
        startedAt.value = Date.now().toString();
      }

      trackingFields.forEach((field) => {
        setTrackingValue(
          form,
          field,
          localStorage.getItem(`smartech_${field}`)
        );
      });

      setTrackingValue(
        form,
        'landing_page',
        localStorage.getItem('smartech_first_page')
      );

      setTrackingValue(
        form,
        'landing_url',
        localStorage.getItem('smartech_landing_url')
      );

      setTrackingValue(
        form,
        'referrer',
        localStorage.getItem('smartech_referrer')
      );

      setTrackingValue(
        form,
        'lead_source',
        leadSource
      );

      setTrackingValue(
        form,
        'first_page',
        localStorage.getItem('smartech_first_page')
      );

      setTrackingValue(
        form,
        'device',
        device
      );

      setTrackingValue(
        form,
        'browser_language',
        navigator.language || ''
      );

      setTrackingValue(
        form,
        'submitted_at',
        new Date().toISOString()
      );
    });
});

document.addEventListener('submit', (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) return;

  if (
    !form.matches(
      '.newsletter-form, .smart-home-survey-form'
    )
  ) {
    return;
  }

  const honeypot = form.querySelector(
    'input[name="website"]'
  );

  const startedAt = form.querySelector(
    '[data-form-started-at]'
  );

  if (honeypot && honeypot.value.trim() !== '') {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  if (startedAt) {
    const elapsed =
      Date.now() - Number(startedAt.value);

    if (!Number.isFinite(elapsed) || elapsed < 500) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
  }

  /*
   * Refresh submission time immediately before submission.
   */
  const submittedAt = form.querySelector(
    '[data-tracking="submitted_at"]'
  );

  if (submittedAt) {
    submittedAt.value = new Date().toISOString();
  }
});